import React, { ReactNode } from 'react'

import '@cosmos/modal/modal-body'

type ModalBodyProps = {
  children: ReactNode
  className?: string
  dataTestId?: string
  id?: string
}

const ModalBody = ({ children, className = '', id = '', dataTestId = '' }: ModalBodyProps) => {
  return (
    <hot-modal-body data-test={dataTestId} id={id} class={className}>
      {children}
    </hot-modal-body>
  )
}

export default ModalBody
